import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["TemplateDetails"] */ "/app/src/shared/templates/template-details.tsx");
